import { bool, oneOf, string } from "prop-types";
import { forwardRef, memo } from "react";

import { themeSizes } from "theme";
import { colorVariants, virtues } from "theme/constants";

import FnrIcon from "UI/FnrIcon";
import FnrIconContainer from "UI/commonContainers/FnrIconContainer";

const FnrContainedIcon = memo(
  forwardRef(
    /**
     * Renders icons in a predictable way that Oscar usually likes
     * @param {object} param0
     * @param {string} param0.icon - the font awesome icon you want
     * @param {size} param0.size
     * @param {string} param0.colorVariant
     * @param {boolean} param0.center
     * @param {boolean} param0.noBackgroundColor
     * @param {virtue} param0.virtue - the virtue the icon is an example of
     * @param {color} param0.color
     * @param {color} param0.backgroundColor
     * @param {boolean} param0.noPadding
     * @param {boolean} param0.isLoading
     * @param {boolean} param0.show - defaults to true. Set to false to hide.
     * @param {number} param0.yCorrection - some icons in certain sizes need tweak on the y axis. Use this to get it perfectly aligned.
     * @param {shadow} param0.shadow
     * @param {boolean} param0.noAnimation
     * @returns
     */
    (
      {
        icon = "sheep fas",
        size = themeSizes.md,
        colorVariant = colorVariants.default,
        center = true,
        noBackgroundColor,
        noPadding,
        shadow,
        ...rest
      },
      ref
    ) => (
      <FnrIconContainer
        ref={ref}
        size={size}
        colorVariant={colorVariant}
        $noBackgroundColor={noBackgroundColor}
        $noPadding={noPadding}
        {...rest}
      >
        <FnrIcon shadow={shadow} center={center} icon={icon} />
      </FnrIconContainer>
    )
  )
);

FnrContainedIcon.propTypes = {
  icon: string,
  size: oneOf(Object.values(themeSizes)),
  colorVariant: oneOf(Object.values(colorVariants)),
  center: bool,
  noBackgroundColor: bool,
  virtue: oneOf(Object.values(virtues)),
  noPadding: bool,
  color: string,
  isLoading: bool,
  backgroundColor: string,
  show: bool,
  shadow: bool,
};

export default FnrContainedIcon;
